import classNames from 'classnames';
import { Select } from 'components/2-molecules/Inputs/Select';
import { useState } from 'react';
import { BeerDuty } from './DutySettings/BeerDutySettings';
import { ChocolateCandyDuty } from './DutySettings/ChocolateCandyDutySettings';
import { CoffeeDuty } from './DutySettings/CoffeeDutySettings';
import { SpiritsDuty } from './DutySettings/SpiritsDutySettings';
import { WineDuty } from './DutySettings/WineDutySettings';
import styles from './ExciseDutyCalculator.module.scss';

export interface ExciseDutyCalculatorProps {
	className?: string;
}

const ExciseDuties: Record<DutyType, { name: string; settings: React.ReactNode }> = {
	spirits: { name: 'Spiritus', settings: <SpiritsDuty /> },
	wine: { name: 'Vin', settings: <WineDuty /> },
	beer: { name: 'Øl', settings: <BeerDuty /> },
	chocolateCandy: { name: 'Chocolade, slik mv.', settings: <ChocolateCandyDuty /> },
	coffee: { name: 'Kaffe', settings: <CoffeeDuty /> },
};

type DutyType = 'spirits' | 'wine' | 'beer' | 'chocolateCandy' | 'coffee';

export const ExciseDutyCalculator: React.FC<ExciseDutyCalculatorProps> = ({ className }) => {
	const [selectedDuty, setSelectedDuty] = useState<DutyType>(null);

	return (
		<div className={classNames(className, styles.ExciseDutyCalculator)}>
			<Select
				id="selectedDuty"
				defaultValue={selectedDuty ?? ''}
				onChange={(e) => {
					setSelectedDuty(e.target.value as DutyType);
				}}
				aria-label="Vælg afgiftstype"
			>
				<option value="" disabled>
					Vælg afgift
				</option>
				{Object.keys(ExciseDuties).map((dutyType: DutyType) => {
					return (
						<option key={dutyType} value={dutyType}>
							{ExciseDuties[dutyType].name}
						</option>
					);
				})}
			</Select>
			{selectedDuty ? ExciseDuties[selectedDuty].settings : null}
		</div>
	);
};
